module.exports = __webpack_public_path__ + "static/media/yardnapha-run-off.e5d6f8fc.mp3";